import PropTypes from "prop-types";

export default PropTypes.shape({
  current_salary: PropTypes.number,
  desired_salary: PropTypes.number,
  first_name: PropTypes.string,
  full_name: PropTypes.string,
  has_driving_licence: PropTypes.bool,
  job_type: PropTypes.string,
  last_name: PropTypes.string,
  location: PropTypes.string,
  nationality: PropTypes.string,
});
